/* eslint-disable */
import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_CATERINPAYMENTDATA, SET_CATERINPAYMENTDATA } from '../actions';
import { appId, apiUrl } from "../components/Helpers/Config";
import Axios from 'axios';
import cookie from 'react-cookies';

export const watchGetPaymentdata = function* () {
  yield takeEvery(GET_CATERINPAYMENTDATA, workerGetPaymentdata);
}

function* workerGetPaymentdata({ orderId }) {
  try {
    const uri = apiUrl + 'cateringreports/cateringPaymentDetails?app_id='+appId+'&order_id='+orderId;
    const result = yield call(Axios.get, uri);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_CATERINPAYMENTDATA, value: resultArr });
  } 
  catch {
    console.log('Get Payment Data Failed');
  }
} 

